import React from "react";

export const InputWapper = ({ children, unit }) => (
  <div style={{ display: "flex", alignItems: "center", width: "100%",padding:"0px 5px" }}>
    {children}
    {unit && (
      <span style={{ marginLeft: 10, }}>
        {unit}
      </span>
    )}
  </div>
);
